import $ from 'jquery'

export default {
    name: 'manage-confirmation',
    components: {},
    props: {
        selected_articles: Array,
        user_id: Number,
        toggle_modal: Number
    },
    data() {
        return {
            fields: [
                { key: 'article', label: 'Article' },
                { key: 'qte', label: 'Qté' },
            ],

            filter: "",
            perPage: 15,
            currentPage: 1,

            save_loading: false,
            has_confirmed: true
        }
    },

    watch: {
        toggle_modal() {
            const confirm = document.getElementById("cfrm-retour");
            confirm.checked = false
            this.has_confirmed = true
            this.save_loading = false
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        submit(selector) {
            const confirm = document.getElementById(selector);
            if (!confirm.checked) { 
                this.has_confirmed = false
                $('.err-msg').fadeIn(500)
                return
            }

            this.save_loading = true
            console.log(this.selected_articles);
            const data = {
                articles: this.selected_articles,
                user_id: this.user_id
            }

            this.$store.dispatch('saveConfirmationRetourStock', data).then((response) => {
                if (response.success) {
                    this.successToast(response.message)
                    confirm.checked = false
                    this.$emit('emitRetourStock')
                    this.$refs.confirm_retour.click()
                } else {
                    if (response.code == 500) {
                        this.errorToast(response.message)
                    }
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.errorToast("Une erreur s'est produite")
            })
        },

        onConfirm() {
            this.has_confirmed = true
            $('.err-msg').fadeOut(500)
        }
    }
}